import { render } from "./textImageSection.vue?vue&type=template&id=1e8cd301&scoped=true"
import script from "./textImageSection.vue?vue&type=script&lang=js"
export * from "./textImageSection.vue?vue&type=script&lang=js"

import "./textImageSection.vue?vue&type=style&index=0&id=1e8cd301&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8cd301"]])

export default __exports__